<template>
  <div class="m-l-50 m-t-30" v-loading="isLoading">
    <common-config :id="id" :form="form" :inputList="inputList" :isLimit="false">
      <template slot="self-config">
        <div class="m-b-10 p-20 bor-ccc pos-rel">
          <div class="tit">收信配置</div>
          <div>
            <el-form-item label="选择邮箱字段">
              <el-select v-model="form.email_fieldId" filterable>
                <el-option 
                  v-for="(option, index) in inputList"
                  :label="option.default.name + '(' + option.default.title + ')'"
                  :value="option.default.field_id">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="m-b-10 p-20 bor-ccc pos-rel">
          <div class="tit">发信配置</div>
          <div>
            <el-form-item label="发件服务器">
              <el-input class="w-200" v-model.trim="form.smtp_host"></el-input>
            </el-form-item>
            <!-- <el-form-item label="是否ssl">
              <el-checkbox v-model="form.is_ssl" :true-label="1" :false-label="0"></el-checkbox>
            </el-form-item> -->
            <el-form-item label="端口">
              <el-input class="w-200" v-model.trim="form.smtp_port"></el-input>
            </el-form-item>
            <el-form-item label="账号">
              <el-input class="w-200" v-model.trim="form.smtp_user"></el-input>
            </el-form-item>
            <el-form-item label="密码">
              <el-input class="w-200" v-model.trim="form.smtp_pass"></el-input>
            </el-form-item>
            <el-form-item label="发件人">
              <el-input class="w-200" v-model.trim="form.send_person"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="m-b-10 p-20 bor-ccc pos-rel">
          <div class="tit">内容中的变量配置</div>
          <div>
            <div class="form-tips">变量公式说明：Y代表年，M代表月，D代表天，H代表时，I代表分，S代表秒，+1代表往前加一个单位，-1代表往后减一个单位，支持小数；可使用&进行多公式连接。例：D+1代表明天，M+1代表下个月，H+1代表一个小时后，I+10代表十分钟后，S+30代表30秒后</div>
            <el-table
              :data="form.params"
              style="width: 100%">
              <el-table-column
                label="标签名称"
                style="width:23%">
                <template scope="scope">
                  <el-input v-model.trim="scope.row.name"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                label="内容变量标签"
                style="width:23%">
                <template scope="scope">
                  <span> {{ scope.row.param }} </span>
                </template>
              </el-table-column>
              <el-table-column
                label="变量类型"
                style="width:23%">
                <template scope="scope">
                  <el-select v-model="scope.row.type" filterable>
                    <el-option 
                      v-for="option in typeOptions"
                      :label="option.name"
                      :value="option.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                label="对应变量"
                style="width:23%">
                <template scope="scope">
                  <el-select v-model="scope.row.value" filterable v-if="scope.row.type == 20">
                    <el-option 
                      v-for="(option, index) in inputList"
                      :label="option.default.name + '(' + option.default.title + ')'"
                      :value="option.default.field_id">
                    </el-option>
                  </el-select>
                  <el-select v-model="scope.row.value" filterable v-else-if="scope.row.type == 30">
                    <el-option 
                      v-for="(option, index) in userInfo"
                      :label="option.field + '(' + option.title + ')'"
                      :value="option.field_id">
                    </el-option>
                  </el-select>
                  <el-input v-model.trim="scope.row.value" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                style="width:8%">
                <template scope="scope">
                  <el-button size="small" @click="deleteParams(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="m-t-10 tx-c">
              <el-button type="primary" @click="addParams">增加一个</el-button>
            </div>
          </div>
        </div>
        <div class="m-b-10 p-20 bor-ccc pos-rel">
          <div class="tit">模板内容配置</div>
          <div v-for="(item, index) in form.templet" class="m-b-10 p-b-10 bor-b-ccc">
            <el-form-item label="标题">
              <el-input class="w-200" v-model.trim="item.title"></el-input>
            </el-form-item>
            <el-form-item label="内容">
              <honray-editor
                :id="'iden_' + index"
                :height="200"
                :uploadImgUrl="host + 'admin/upload'"
                :uploadHeaders="header"
                v-model="item.content"></honray-editor>
            </el-form-item>
            <div class="m-t-10">
              <el-button @click="deleteTemplet(index)">删除</el-button>
            </div>
          </div>
          <div class="m-t-10">
            <el-button type="primary" @click="addTemplet">增加一个</el-button>
          </div>
        </div>
        <!-- <el-button @click="log">log</el-button> -->
      </template>
    </common-config>
  </div>
</template>

<style scoped>
</style>

<script>
  import http from '../../../../assets/js/http'
  import flowConfig from '../../../../config/flowConfig'
  import commonConfig from './commonConfig'
  import cudConfig from '../../../Common/business/cudConfig'
  import honrayEditor from '../../../Common/business/inputs/honrayEditor'
  export default {
    data() {
      return {
        isLoading: false,
        id: 0,
        contentId: '',
        modelId: -1,
        form: {
          name: '',  // 操作名
          rule_name: '', // 权限标识
          model_name: '',  // 所选模型
          email_fieldId: '', // 选择邮箱字段
          smtp_host: '', // 发送服务器
          // is_ssl: 0,    // 是否ssl
          smtp_port: '',    // 端口
          smtp_user: '',    // 账号
          smtp_pass: '',    // 密码
          send_person: '',    // 发送人
          params: [],    // 变量信息
          templet: []    // 模板
        },
        typeOptions: [
          { id: 10, name: '日期变量' },
          { id: 20, name: '表单字段' },
          { id: 30, name: '用户信息' }
        ],
        paramsModel: {
          name: '',
          type: '',
          param: '',
          value: ''
        },
        templetModel: {
          title: '',
          content: ''
        },
        host: '',
        header: '',
        userInfo: [], // 用户信息
        inputList: []  // 控件数组
      }
    },
    methods: {
      async getUserInfo() {
        let res = await this.apiGet('cms/deals/fields/1') // 写死1即可
        let data = this.promiseHandler(data, res)
        let newData = []
        _(data).forEach((res) => {
          if (res.field != 'id' && res.field != 'password') {
            newData.push(res)
          }
        })
        this.userInfo = newData
      },
      getDetail() {
        this.isLoading = true
        this.apiGet(`cms/deals/${this.id}`).then((res) => {
          if (res.code == 200) {
            this.form.name = res.data.content_name
            this.form.rule_name = res.data.rule_name
            this.form.model_name = res.data.model_name
            if (res.data.config) {
              this.form.email_fieldId = res.data.config.email_fieldId
              this.form.smtp_host = res.data.config.smtp_host
              // this.form.is_ssl = res.data.config.is_ssl
              this.form.smtp_port = res.data.config.smtp_port
              this.form.smtp_user = res.data.config.smtp_user
              this.form.smtp_pass = res.data.config.smtp_pass
              this.form.send_person = res.data.config.send_person
              this.form.params = res.data.config.params
              this.form.templet = res.data.config.templet
            }
            this.modelId = res.data.model_id
            this.getInputList()
          } else {
            _g.dealError(this, res)
          }
          this.isLoading = false
        })
      },
      getInputList() {  // 获取控件列表
        this.apiGet(`form/models/${this.modelId}/fields`).then((res) => {
          if (res.code == 200) {
            this.inputList = res.data
          }
        })
      },
      addParams() {
        let newObj = _.cloneDeep(this.paramsModel)
        let param = this.getUniqParam()
        newObj.param = `{$${param}}`
        this.form.params.push(newObj)
      },
      deleteParams(index) {
        this.form.params.splice(index, 1)
      },
      addTemplet() {
        this.form.templet.push(_.cloneDeep(this.templetModel))
      },
      deleteTemplet(index) {
        this.form.templet.splice(index, 1)
      },
      getUniqParam() {
        let start = 65 // A的ascii码
        let param = ''
        for (let i = 0; i < 26; i++) {
          param = String.fromCharCode(start + i)
          let repeat = false
          _(this.form.params).forEach((res) => {
            if (res.param == `{$${param}}`) {
              repeat = true
              return false
            }
          })
          if (!repeat) {
            break
          }
        }
        return param
      },
      log() {
        console.log(this.form)
      }
    },
    created() {
      this.host = HOST
      this.header = _g.updateHttpHeader()
      this.id = parseInt(this.$route.params.id)
      this.contentId = parseInt(this.$route.params.contentId)
      this.getDetail()
      this.getUserInfo()
    },
    components: {
      commonConfig,
      cudConfig,
      honrayEditor
    },
    mixins: [http, flowConfig]
  }
</script>


// WEBPACK FOOTER //
// emailConfig.vue?b61672ba